import { useEffect } from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { apiGetPolicyInfo } from "utils/API/TrxNowAPI";
import { PolicyLookupSpinner } from "webapp/components/PolicyLookupSpinner";
import "./BMOMemberInformationForm.scss";
import { devLog } from "utils/devLog";

const policyMap = new Map();
function BMOMemberInformationForm(props) {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [searchValue, setSearchValue] = useState(props.currState.MemberLookup.memberRef);
  const [firstName, setFirstName] = useState(props.currState.MemberLookup.firstName);
  const [lastName, setLastName] = useState(props.currState.MemberLookup.lastName);

  const [searchType, setSearchType] = useState(props.currState.MemberLookup.searchType);
  const [coverageType, setCoverageType] = useState(props.currState.MemberLookup.coverageType);
  const [memberInfo, setMemberInfo] = useState(undefined);
  const [contacts, setContacts] = useState([]);
  const [contactToDisplay, setContactToDisplay] = useState([]);
  const [selectedContact, setSelectedContact] = useState(null);
  const [selectedAccount, setSelectedAccount] = useState(null);
  const [createContacts, setCreateContact] = useState(["Create a new contact", ""]);

  const [checkDuplicateName, setCheckDuplicateName] = useState(false);
  const [showAddNew, setShowAddNew] = useState(false);
  const [newSelect, setNewSelect] = useState(false);
  const [partnerCode, setPartnerCode] = useState(props.currState.localGroup);

  useEffect(() => {
    // devLog(props);
    setSelectedContact("");
    setSelectedAccount("");
    setContactToDisplay(undefined);
    onSubmit();
    setNewSelect(false);
    setShowAddNew(false);
  }, []);

  const onLoad = (success) => {
    if (typeof props.onLoad === "function") {
      props.onLoad(success);
    }
  };

  const onSelect = (sa, sc) => {
    if (typeof props.onUserSelect === "function") {
      props.onUserSelect(sa, sc);
    }
  };

  const onSelectContact = (sc) => {
    setSelectedContact(sc);
    setShowAddNew(false);
    setNewSelect(false);
    onSelect(selectedAccount, sc);
  };

  const onSelectNew = (sc) => {
    setNewSelect(true);
    setShowAddNew(true);
    setSelectedContact(null);
    onSelect(selectedAccount, sc);
  };

  const onAddNew = (sc) => {
    setSelectedContact(sc);
    onSelect(selectedAccount, sc);
  };

  const onSelectAccount = (sa) => {
    setSelectedAccount(sa);
    setSelectedContact(null);
    setShowAddNew(false);
    setNewSelect(false);
    onSelect(sa, selectedAccount);
  };

  const contactDisplay = (contacts) => {
    let cons = [];
    if (typeof memberInfo === "undefined" || !contacts) {
      return;
    }

    contacts.map((con, index) => {
      if (con.accountRef === selectedAccount.accountRef) {
        cons.push(con);
        // devLog("add contacts: ", con);
      }
    });
    setContactToDisplay(cons);

    checkDuplicateContact(props.currState.FirstName, props.currState.LastName, cons);
  };

  useEffect(() => {
    contactDisplay(contacts);
    setSelectedContact(null);
    setShowAddNew(false);
    setNewSelect(false);
  }, [selectedAccount]);

  const onSubmit = (e) => {
    setError("");
    // e.preventDefault();
    // devLog("Execute policy search...", searchValue);

    if (policyMap.has(searchValue)) {
      // onMemberInfo(policyMap.get(searchValue), selectedContact);
      setMemberInfo(policyMap.get(searchValue));
      setLoading(false);
      onLoad(true);
      return;
    }

    setLoading(true);
    //Lookup: Callout
    apiGetPolicyInfo({
      data: {
        providerRef: props.currState.providerRef,
        firstName: firstName,
        lastName: lastName,
        coverageType: coverageType,
        searchType: searchType,
        partnerCode: partnerCode,
      },
      companyParams: props.currState.currentCompanyParams,
    })
      //Lookup: Success
      .then((json) => {
        // devLog("JSON", json);
        if (typeof json.data.memberInfo === "object" && typeof json.data.contactInfo === "object") {
          if (!json.data.error) {
            setContactToDisplay([]);
            setContacts(json.data.contactInfo);
            // onMemberInfo(json.data.memberInfo, json.data.contactInfo);
            setMemberInfo(json.data.memberInfo);
            // onSelect(json.data.memberInfo, json.data.contactInfo);
            onLoad(true);
          } else {
            setContacts([]);
            setContactToDisplay([]);
            setContactToDisplay();
            setError(json.data.error.message);
            onLoad(false);
          }
        } else if (typeof json.data.error === "object") {
          setContacts([]);
          setContactToDisplay([]);
          setError(json.data.error.message);
          policyMap.delete(searchValue);
          onLoad(false);
        } else {
          setContactToDisplay([]);
          setContacts([]);
          setError(t("BWC.PolicyInformation.UnableToFindMember"));
          policyMap.delete(searchValue);
          onLoad(false);
        }
        setLoading(false);
      })

      //Lookup: Failed
      .catch((e) => {
        devLog("error", e);
        setLoading(false);
        setContacts([]);
        setError(t("BWC.PolicyInformation.UnableToFindMember"));
        onLoad(false);
      });
  };
  const onUserBack = (e) => {
    e.preventDefault();
    if (typeof props.onUserBack === "function") {
      props.onUserBack();
    }
  };

  const checkDuplicateContact = (firstName, lastName, conList) => {
    setCheckDuplicateName(false);
    conList.map((con, index) => {
      if (
        con.firstName.toUpperCase().trim() === firstName.toUpperCase().trim() &&
        con.lastName.toUpperCase().trim() === lastName.toUpperCase().trim()
      ) {
        setCheckDuplicateName(true);
      }
      return checkDuplicateContact;
    });
  };

  return (
    <>
      <div className="formContainer">
        {memberInfo ? (
          <div className="policyData">
            <div className="policyHeader">
              <h4>{t("description.ContractInformationHeader2")}</h4>
              <div style={{ fontSize: ".8rem" }}>Name | Policy Number</div>
              <hr />
              {memberInfo.map((member, index) => {
                return (
                  <>
                    <div className="contact-list">
                      <input
                        className="vehicleSelector"
                        type="radio"
                        name="accountSelector"
                        checked={selectedAccount === member ? true : false}
                        onClick={(e) => {
                          // setSelectedAccount(member);
                          onSelectAccount(member);
                        }}
                        required={true}
                      />
                      <div className="vehicle-list-item-col-1">
                        <b className="name-h5">{member.name}</b>
                      </div>
                    </div>
                    <hr />
                  </>
                );
              })}
            </div>
          </div>
        ) : (
          <></>
        )}

        {contactToDisplay && selectedAccount ? (
          <>
            <div className="policyData">
              <div className="policyHeader">
                <h4>{t("description.SelectDriverHeader")}</h4>
                {/* <div style={{ fontSize: ".8rem" }}>Name | Policy Number</div> */}
                <hr />
                {contactToDisplay.map((con, index) => {
                  return (
                    <>
                      <div className="contact-list">
                        <input
                          className="vehicleSelector"
                          type="radio"
                          name="contactSelector"
                          checked={selectedContact === con ? "selected" : ""}
                          onClick={(e) => {
                            // setSelectedContact(con);
                            onSelectContact(con);
                          }}
                          required={true}
                        />
                        <div className="vehicle-list-item-col-1">
                          <b className="name-h5">
                            {con.firstName} {con.lastName}
                          </b>
                        </div>
                      </div>
                      <hr />
                    </>
                  );
                })}

                {!checkDuplicateName && (
                  <>
                    <div className="contact-list">
                      <input
                        className="vehicleSelector"
                        type="radio"
                        name="contactSelector"
                        checked={newSelect === true ? "select" : ""}
                        onClick={(e) => {
                          // setSelectedContact(con);
                          onSelectNew(newSelect);
                        }}
                        required={true}
                      />
                      <div className="vehicle-list-item-col-1">
                        <b className="name-h5">Add a new driver</b>
                      </div>
                    </div>
                    <hr />
                  </>
                )}
              </div>
            </div>

            {!checkDuplicateName && showAddNew ? (
              <>
                <div className="policyData">
                  <div className="policyHeader">
                    <h4>{t("description.AddContactInformationHeader")}</h4>
                    <hr />
                    <div className="contact-list">
                      <input
                        className="vehicleSelector"
                        type="radio"
                        name="policy-vehicle"
                        checked={selectedContact === "Add New"}
                        onClick={(e) => {
                          // setSelectedContact(undefined);
                          // setSelectedContact(undefined);
                          // onSelect.onSelectContact(undefined);
                          onAddNew("Add New");
                        }}
                      />
                      <div className="vehicle-list-item-col-1">
                        <b className="name-h5">
                          {props.currState.FirstName} {props.currState.LastName}
                        </b>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <></>
            )}
          </>
        ) : (
          <></>
        )}
      </div>
      {error ? (
        <div className="errorSection">
          <b className="error">{error}</b>
          <div>
            <button className="ui-btn" onClick={onUserBack}>
              {t("description.TryAgain")}
            </button>
          </div>
        </div>
      ) : (
        <></>
      )}
      {loading ? <PolicyLookupSpinner title={`ContractLookupTitleBWC`} message={`PolicyLookupMessage`} /> : <></>}
    </>
  );
}

export default BMOMemberInformationForm;
